import React from "react";
import { IconButton, Tooltip } from "components";
import ManagerHeader from "features/manager/components/ManagerHeader";
import { HelpIcon } from "../managerHome/components/icons";

/**
 * Create-flow top bar — the shared manager nav (<ManagerHeader />), same as the
 * dashboard, trimmed to just the Help action (no search, no "+ New Game"). The
 * brand lockup, the /manage link, and the account button all come from
 * ManagerHeader.
 */
const CreateHeader = () => (
  <ManagerHeader
    actions={
      <Tooltip title="Help & shortcuts">
        <span>
          <IconButton variant="ghost" label="Help">
            <HelpIcon />
          </IconButton>
        </span>
      </Tooltip>
    }
  />
);

export default CreateHeader;
